function useTagInputStyle(_ref) {
  var size = _ref.size,
      allowLineBreak = _ref.allowLineBreak,
      hasInputWrapper = _ref.hasInputWrapper;
  var wrapperStyleProps = {
    alignItems: 'items-center',
    boxShadow: 'focus-within:shadow-outline-blue'
  };
  var inputStyleProps = {
    textColor: 'text-gray-600',
    borderWidth: 'border-0',
    boxShadow: 'focus:shadow-none',
    display: 'block',
    flexGrow: 'flex-grow',
    padding: 'py-0',
    margin: 'my-1'
  };

  if (allowLineBreak) {
    wrapperStyleProps.flexWrap = 'flex-wrap';
  } else {
    wrapperStyleProps.overflow = 'overflow-x-auto';
  }

  switch (size) {
    case 'sm':
      wrapperStyleProps.padding = hasInputWrapper ? ['px-1', 'py-0.5'] : undefined;
      inputStyleProps.fontSize = 'text-sm';
      inputStyleProps.lineHeight = 'leading-5';
      inputStyleProps.margin = 'my-0.5';
      break;

    case 'md':
    default:
      wrapperStyleProps.padding = hasInputWrapper ? 'p-1' : undefined;
      inputStyleProps.fontSize = 'text-base';
      inputStyleProps.lineHeight = 'leading-6';
      inputStyleProps.margin = 'my-1';
      break;
  }

  return {
    wrapperStyleProps: wrapperStyleProps,
    inputStyleProps: inputStyleProps
  };
}

export default useTagInputStyle;
//# sourceMappingURL=styles.esm.js.map
